/* Kratus — sport-collection-showcase: botones prev/next (scroll por ancho de card)
   + barra de progreso (thumb = proporcion visible/total) ligada al scroll. Mismo
   esqueleto vanilla que section-home-favourite-looks.js (sin GSAP: rAF simple basta
   para un listener de scroll pasivo) — reemplaza el reveal GSAP + zoom-on-hover de la
   version anterior en grid, obsoleto ahora que el layout es un carrusel de category-cards
   (spec eclipse-reconstruction §2.5). Respeta prefers-reduced-motion desactivando el
   smooth-scroll de los botones; el hover de la flecha circular por card es CSS puro. */

window.KratusMotion && window.KratusMotion.ready('sport-collection-showcase', function (root) {
  var sections = (root || document).querySelectorAll('[data-sport-showcase]');
  if (!sections.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!document.documentElement.dataset.sportShowcaseResizeBound) { // bind once (evita listeners apilados en shopify:section:load, patron kratus-motion.js header/hero-eclipse): recalcula sobre los tracks vivos en el DOM, nunca sobre una referencia capturada del track viejo
    document.documentElement.dataset.sportShowcaseResizeBound = '1';
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-sport-showcase-track]').forEach(function (liveTrack) {
        liveTrack.dispatchEvent(new Event('scroll'));
      });
    }, { passive: true });
  }

  sections.forEach(function (section) {
    if (section.dataset.sportShowcaseBound) return; // guard: bind once (shopify:section:load puede re-disparar)
    section.dataset.sportShowcaseBound = '1';

    var track = section.querySelector('[data-sport-showcase-track]');
    var prevBtn = section.querySelector('[data-sport-showcase-prev]');
    var nextBtn = section.querySelector('[data-sport-showcase-next]');
    if (!track) return;

    var ticking = false;

    function cardStep() {
      var card = track.querySelector('[data-sport-showcase-card]');
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var width = card ? card.getBoundingClientRect().width : track.clientWidth * 0.8;
      return width + gap;
    }

    function update() {
      ticking = false;
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    update();
  });
});
